import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Grid,
  IconButton,
  Icon,
  Switch,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import {BackdropCircular} from 'components';
import {addPatientCertificationApi, deletePatientCertificationsApi, setPatientCertificationApi} from 'api/others';
import EditPatientCertifications from './editPatientCertifications';


const PatientCertifications = ({product}) => {
  const dispatch = useDispatch();
  const [editableCertification, setEditableCertification] = useState(null);
  const [isOpenEditCertification, setIsOpenEditCertification] = useState(false);
  const {patientCertification, productCustomOptions, loadingPatientCertification} = useSelector((state) => state.products);

  // A certification is the option built from its template group. Certifications created before
  // templates were used carry no group, so they are still recognised by option_title_id.
  const findOption = (certification) => productCustomOptions.find((option) => (
    certification.certification_family && option.certification_family
      ? option.certification_family === certification.certification_family
      : option.option_title_id && option.option_title_id === certification.option_title_id
  ));

  const options = {
    filterType: 'none',
    selectableRows: 'none',
    download: false,
    search: false,
    print: false,
    filter: false,
    viewColumns: false,
    pagination: false,
    sort: false
  };

  const certificationsColumns = [
    {
      name: 'title',
      label: 'Title',
      options: {
        setCellHeaderProps: () => ({ style: { width: '20%' } }),
        customBodyRenderLite: (dataIndex) => {
          const certification = patientCertification[dataIndex];
          const option = findOption(certification);


          return (
            <div>
              {option ? option.title : certification.title}
            </div>
          );
        }
      }
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        setCellHeaderProps: () => ({ style: { width: '60%' } }),
        customBodyRenderLite: (dataIndex) => {
          const certification = patientCertification[dataIndex];
          const option = findOption(certification);


          return (
            <div>
              {option ? option.values[0].title : certification.values[0].title}
            </div>
          );
        }
      }
    },
    {
      name: 'action',
      label: 'Enable',
      options: {
        setCellHeaderProps: () => ({ style: { width: '10%' } }),
        customBodyRenderLite: (dataIndex) => {
          const certification = patientCertification[dataIndex];
          const option = findOption(certification);

          return (
            <Switch
              color="primary"
              name="patient_certification_active"
              checked={!!option && !option.disabled}
              onClick={(event) => {
                const enabled = event.target.checked;

                // Turning off follows the option this product actually has, not the row in the
                // shared list: a product published before templates carries a plain copied
                // option, and asking the store to drop a template would leave that one in place.
                if (!enabled) {
                  if (option?.certification_family) {
                    setPatientCertificationApi({
                      dispatch, product, certification: option.certification_family, enabled
                    });
                  } else if (option) {
                    deletePatientCertificationsApi({dispatch, product, disabledOption: option});
                  }

                  return;
                }

                // Turning on has no option to go by, so the list decides. Only the four
                // certifications the ticket covers have a template to build from.
                if (certification.certification_family) {
                  setPatientCertificationApi({
                    dispatch, product, certification: certification.certification_family, enabled
                  });
                } else {
                  addPatientCertificationApi({dispatch, option: {...certification, product_sku: product.sku}});
                }
              }}
            />
          );
        }
      }
    },
    {
      name: 'Edit',
      lable: 'Edit',
      options: {
        setCellHeaderProps: () => ({ style: { width: '10%' } }),
        customBodyRenderLite: (dataIndex) => {
          const certification = patientCertification[dataIndex];
          const option = findOption(certification);

          return (
            <>
              {option ?
                <IconButton
                  className="mr-2"
                  title="Edit"
                  onClick={() => {
                    setEditableCertification(option);
                    setIsOpenEditCertification(true);
                  }}
                >
                  <Icon className="text-gray">edit</Icon>
                </IconButton>
                :
                null
              }
            </>
          );
        }
      }
    }
  ];

  return (
    <Grid container spacing={3}>
      <MUIDataTable
        className="my-10"
        data={patientCertification}
        columns={certificationsColumns}
        options={options}
      />
      {isOpenEditCertification &&
      <EditPatientCertifications
        open={isOpenEditCertification}
        onClose={setIsOpenEditCertification}
        certification={editableCertification}
      />
      }
      <BackdropCircular loading={loadingPatientCertification} />
    </Grid>
  );
};

export default PatientCertifications;
